(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodGtmDataLayer', sodGtmDataLayer);

    function sodGtmDataLayer(lodash) {
        return {
            restrict: 'EA',
            scope: {onDataLayer: '@', datalayer: '@?'},
            link: sodGtmDataLayerLink,
        };

        function isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        function objectCompare(obj1, obj2) {
            //Loop through properties in object 1
            for (var p in obj1) {
                //Check property exists on both objects
                if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

                switch (typeof (obj1[p])) {
                    //Deep compare objects
                    case 'object':
                        if (!Object.compare(obj1[p], obj2[p])) return false;
                        break;
                    //Compare function code
                    case 'function':
                        if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) return false;
                        break;
                    //Compare values
                    default:
                        if (obj1[p] != obj2[p]) return false;
                }
            }

            //Check object 2 for any extra properties
            for (var p in obj2) {
                if (typeof (obj1[p]) == 'undefined') return false;
            }
            return true;
        };

        function sodGtmDataLayerLink(scope, elem, attr) {
            elem.on(scope.onDataLayer, callback);
            var datalayer = lodash.get(scope, 'datalayer');

            function callback() {
                if (lodash.isEmpty(datalayer)) return;

                var datalayerObj = {};
                if (typeof datalayer === 'string' && isJson(datalayer)) {
                    datalayerObj = JSON.parse(datalayer);
                }

                var lastDataLayer = window.dataLayer.slice(-1);
                if (!lodash.isEmpty(lastDataLayer)) {
                    lastDataLayer = lastDataLayer[0];
                    delete lastDataLayer['gtm.uniqueEventId'];
                } else {
                    lastDataLayer = {};
                }

                if (!lodash.isEmpty(datalayerObj)
                    && !objectCompare(lastDataLayer, datalayerObj)) {
                    window.dataLayer.push(datalayerObj);
                }
            }

            scope.$on('$destroy', function () {
                callback();
            });
        }
    }
})();